"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ShowHideIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.475 5.768c1.485-.7 3.007-1.05 4.568-1.05 3.82 0 7.409 2.094 10.768 6.28a1.25 1.25 0 010 1.566c-1.414 1.762-2.87 3.154-4.365 4.174l2.11 2.111a1 1 0 01-1.413 1.414L3.586 4.707A1 1 0 115 3.293l2.475 2.475zm8.74 8.74a5 5 0 00-6.929-6.929l6.929 6.928zM4.52 7.662l2.713 2.714a5 5 0 006.182 6.182l1.79 1.79a10.36 10.36 0 01-3.163.495c-3.819 0-7.408-2.094-10.768-6.28a1.25 1.25 0 010-1.565c1.06-1.32 2.141-2.432 3.246-3.336z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.221 10.321a3 3 0 114.165 4.165l-4.165-4.165z",
    opacity: ".8"
  })));
});
ShowHideIcon.category = 'Action';
var _default = ShowHideIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/ShowHideIcon.js
// module id = 1146
// module chunks = 0